import React from "react";

const Terms = () => {
  return (
  <main>
    <h2 className="adm_com_pg_tit">이용약관</h2>
    <div className="adm_com_pg_content">
    이용약관 내용이 나오는 영역
    </div>
  </main>
  );
};

export default Terms;
